/**
 * Created by wangqian on 18/6/21.
 */
// 本地测试服务器
let localHost = 'https://api.gcw.net:7777'
// let localHost = 'http://192.168.100.169:7777'
// let localHost = 'https://api-zc.shigongbang.com:7777'
let localHostUserApi = "https://api.sgbwl.com/memberCenter";
let localHostLogin = "https://user.gcw.net";



// 生产服务器

let aliyunHost = 'https://api.gcw.net:7777'
// let VUE_APP_APIUSER = "https://api.sgbwl.com/memberCenter";
let VUE_APP_ZHAOCAI = 'https://zhaocai.jingyingbang.com'
let VUE_APP_APIRECRUITMENT = "https://api.sgbwl.com/sgb-zhaocai"; // 招采
// let VUE_APP_PERSONURL = 'https://user.jingyingbang.com'
// let aliyunHost = 'http://192.168.100.169:7777'
// let aliyunHost = 'https://api-zc.shigongbang.com:7777'

export const HOST = (process.env.NODE_ENV === 'production') ? aliyunHost : localHost
// export const userApi = (process.env.NODE_ENV === 'production') ? VUE_APP_APIUSER : localHostUserApi
export const userApi = process.env.VUE_APP_APIUSER;
export const zchref = process.env.NODE_ENV === 'production' ? VUE_APP_ZHAOCAI : "https://zhaocai.gcw.net"
// export const loginUrl = process.env.NODE_ENV === "production" ? VUE_APP_PERSONURL : localHostLogin;
export const loginUrl = process.env.VUE_APP_PERSONURL;

export const recruitmentInfoUrl = VUE_APP_APIRECRUITMENT;



const TIMEOUT = 500000

export const AppConfig = {
  host: HOST,
  timeout: TIMEOUT
}
